export default {
  handleCurrentIcon(state, icon) {
    state.currentIcon = icon
  },
  handleCurrentMenu(state, currentMenu) {
    state.currentMenu = currentMenu
  },
  handleCurrentSubmenu(state, currentSubmenu) {
    state.currentSubmenu = currentSubmenu
  },
  handleStampType(state, stampType) {
    state.stampType = stampType
  },
  handleStampEnabled(state, value) {
    state.stampEnabled = value;
  },
  handleStampUrl(state, [stampUrl, aspectRatio]) {
    state.stamp.url = stampUrl;
    state.stamp.aspectRatio = aspectRatio;
  },
  handleToken(state, token) {
    state.token = token
  },
  handlePlaying(state, playing) {
    state.playing = playing;
  },
  duration(state, duration) {
    state.duration = duration;
  },
  handleCurrentProgress(state, currentProgress) {
    state.currentProgress = currentProgress;
  },
  handleAnimations(state, value) {
    state.animations = value;
  },
  handleMusicList(state, musicList) {
    state.musicList = musicList;
  },
  handleMyMusicList(state, myMusicList) {
    state.myMusicList = myMusicList
  },
  handleMaterialList(state, materialList) {
    state.materialList = materialList;
  },
  handleCurrentMusic(state, currentMusic) {
    state.currentMusic = currentMusic;
  },
  handleMyVideoMusic(state, myVideoMusic) {
    state.myVideoMusic = myVideoMusic;
    state.setupMusic = true;
    state.myVideoMusicStartEnd = state.musicStartEnd;
    state.myMusicVolume = state.musicVolume;
  },
  handleMusicStartEnd(state, musicStartEnd) {
    state.musicStartEnd = musicStartEnd;
    if (state.myVideoMusic.id === state.currentMusic.id) {
      state.myVideoMusicStartEnd = musicStartEnd;
    }
  },
  handleSetupMusic(state, setupMusic) {
    state.setupMusic = setupMusic;
  },
  handleVideoStartEnd(state, videoStartEnd) {
    state.videoStartEnd = videoStartEnd;
  },
  handleMusicVolume(state, musicVolume) {
    state.musicVolume = musicVolume;
    if (state.myVideoMusic.id === state.currentMusic.id) {
      state.myMusicVolume = musicVolume;
    }
  },
  handleMyVideoMusicVolume(state, myVideoMusicVolume) {
    state.myVideoMusicVolume = myVideoMusicVolume;
  },
  handleMyVideoMusicMute(state, myVideoMusicMute) {
    state.myVideoMusicMute = myVideoMusicMute;
  },
  handleActiveFragmentIndex(state, i) {
    state.activeFragmentIndex = i;
  },
  handleActiveTransitionIndex(state, i) {
    state.activeTransitionIndex = i;
  },
  handleFragments(state, value) {
    state.fragments = value;
  },
  handleEffectHover(state, effectId) {
    state.hoveringEffectId = effectId;
  },
  // 素材元素选中 TODO: multiple selection
  handleEffectSelect(state, value) {
    state.selectedEffectIds = value;
  },
  handleEffectDrag(state, value) {
    state.effectDragging = value;
  },
  handleEffectReorder(state, value) {
    state.effectReordering = value;
  },
  handleEffectEdit(state, value) {
    state.effectEditing = value;
  },
  handleNextEffectOrder(state, value) {
    state.nextEffectOrder = value;
  },
  handleTimelineHeight(state, value) {
    state.timelineHeight = value;
  },
  handlePreviewVisible(state, value) {
    state.previewVisible = value;
  },
  handleEffects(state, effects) {
    state.effects = effects;
  },
  handleEditStatus(state, editStatus) {
    state.editStatus = editStatus
  },
  handleScreenRatio(state, screenRatio) {
    state.screenRatio = screenRatio
  },
  handleShowTransitionList(state, showTransitionList) {
    if (state.showSubVideoClipList) {
      state.showSubVideoClipList = false
    }
    state.showTransitionList = showTransitionList;
  },
  handleShowSubVideoClipList(state, showSubVideoClipList) {
    if (state.showTransitionList) {
      state.showTransitionList = false
    }
    state.showSubVideoClipList = showSubVideoClipList;
  },
  handleVideoName(state, videoName) {
    state.videoName = videoName;
  },
  handleScreenHeight(state, screenHeight) {
    state.screenHeight = screenHeight;
  },
  handleTrackSelect(state, value) {
    state.selectedTrackId = value;
  },
  handleTrackEdit(state, value) {
    state.trackEditing = value;
  },
  handlePreviewSettings(state, value) {
    state.previewSettingsOpen = value;
  },
  handleLanguageLookup(state, value) {
    state.languageLookup = value;
    state.languageLoaded = true;
  },
  handleLanguageSelect(state, value) {
    state.selectedLanguages = value;
  },
  handleLanguageSex(state, value) {
    state.languageSex = value;
  },
  handleUseTTSLanguages(state, value) {
    state.useTTSLanguages = value;
  },
  // handleTTSLanguageSelect(state, value) {
  //   state.ttsLanguages = value;
  // },
  handlePreviewLanguageSelect(state, value) {
    state.previewLanguage = value;
  },
  handleLoading(state, value) {
    state.loading = value;
  },
  handleTranslationEnabled(state, value) {
    state.translationEnabled = value;
  },
  handleFontList(state, value) {
    state.fontList = value;
  },
  handleTtsEnabled(state, value) {
    state.ttsEnabled = value;
  },
  handleTTSRule(state, value) {
    state.ttsRule = value;
  },
  handleID(state, value) {
    state.id = value;
  },
  handleMusicMenuIsPlaying(state, musicMenuIsPlaying) {
    state.musicMenuIsPlaying = musicMenuIsPlaying
  },
  handleMusicInfoIsPlaying(state, musicInfoIsPlaying) {
    state.musicInfoIsPlaying = musicInfoIsPlaying
  },
  handleSeoTitleList(state, seoTitleList) {
    state.seoTitleList = seoTitleList
  },
  handleSeoTitleListKeyData(state, seoTitleListKeyData) {
    state.seoTitleListKeyData = seoTitleListKeyData
  },
  handleTemplateList(state, templateList) {
    state.templateList = templateList;
  },
  handlePreviewTemplate(state, value) {
    state.previewTemplate = value;
  },
  handleDraftId(state, value) {
    state.draftId = value;
  },
  handleFragmentReorder(state, value) {
    state.fragmentReordering = value;
  },
  handleNextFragmentOrder(state, value) {
    state.nextFragmentOrder = value;
  },
  handleContextMenuOpen(state, value) {
    state.contextMenu.visible = true;
    state.contextMenu.x = value.x;
    state.contextMenu.y = value.y;
    state.contextMenu.items = value.items || [];
  },
  handleContextMenuClose(state) {
    state.contextMenu.visible = false;
  },
  handleVideoTemplateList(state, value) {
    state.videoTemplateList = value;
  },
  handleTemplateSceneList(state, value) {
    state.templateSceneList = value;
  },
  handleTemplateIndustryList(state, value) {
    state.templateIndustryList = value;
  },
  handleTemplateStyleList(state, value) {
    state.templateStyleList = value;
  },
  handleTemplateMediaList(state, value) {
    state.templateMediaList = value;
  },
  handleFragmentTypeList(state, value) {
    state.fragmentTypeList = value;
  },
  handleTemplateId(state, value) {
    state.templateId = value;
  },
  handleBackUrl(state, value) {
    state.backUrl = value;
  },
  handleTemplatePlayerVisible(state, value) {
    state.templatePlayerVisible = value;
  },
  handleTemplatePlayerData(state, value) {
    state.templatePlayerData = value;
  },
  handleContainerEdit(state, value) {
    state.editingContainer = value;
  },
  handlePresets(state, value) {
    state.presets = value;
  },
  handlePresetsCats(state, value) {
    state.presetsCats = value;
  },
  handleRecordDisabled(state, value) {
    state.recordDisabled = value;
  },
  handleUndoStack(state, value) {
    state.undoStack = value;
  },
  handleUndoPos(state, value) {
    state.undoPos = value;
  },
  handleLiFisherSites(state, value) {
    state.liFisherSites = value;
  },
  handlePlayerScale(state, value) {
    state.playerScale = value;
  },
  handlePosterVisible(state, value) {
    state.posterVisible = value;
  },
  handlePosterTitle(state, value) {
    state.posterTitle = value;
  },
  handlePosterCurrent(state, value) {
    state.ms_cover = value;
  },
  handlePosterThumbnail(state, value) {
    state.thumbnail = value;
  },
  handlePosterMetadata(state, value) {
    state.posterMetadata = value;
  },
  handleFilterShowing(state, value) {
    state.filterShowing = value;
  },
  handleTimelineFilter(state, value) {
    state.timelineFilter = value;
  },
  handleRenameVisible(state, value) {
    state.renameVisible = value;
  },
  handleGridShow(state, value) {
    state.gridShowing = value;
  },
  handleShapeNames(state, value) {
    state.shapeNames = value;
  },
  handleShapeMetadata(state, value) {
    state.shapeMetadata = value;
  },
  handleShapes(state, value) {
    state.shapes = value;
  },
  handleContainers(state, value) {
    state.containers = value;
  },
  handleEffectNames(state, value) {
    state.effectNames = value;
  },
  handleGeneralEffects(state, value) {
    state.generalEffects = value;
  },
  handleTextEffects(state, value) {
    state.textEffects = value;
  },
  handleTransitionNames(state, value) {
    state.transitionNames = value;
  },
  handleTransitions(state, value) {
    state.transitions = value;
  },
  handleMealDialogVisible(state, value) {
    state.showMealDialog = value;
  },
  handleKeyboardShortcutShow(state, value) {
    state.keyboardShortcutShowing = value;
  },
  handleDark(state, value) {
    state.isDark = value;
  },
  handleAudios(state, value) {
    state.audios = value;
  },
  handleAudioSelect(state, value) {
    state.selectedAudioId = value;
  },
  handleAudioEdit(state, value) {
    state.audioEditing = value;
  },
  handleUploadModalShow(state, value) {
    state.uploadModalShowing = value;
  },
  handleUploadModalType(state, value) {
    state.uploadModalType = value;
  },
  handleUploadModalMarker(state, value) {
    state.uploadModalMarker = value;
  },
  handleUpload(state, value) {
    state.uploading = value;
  },
  handleUploadDone(state, value) {
    state.uploadDone = value;
  },
  handleUploadSpace(state, value) {
    state.uploadSpace = value;
  },
  handleUploadTotalSize(state, value) {
    state.uploadTotalSize = value;
  },
  handleUploadFinishSize(state, value) {
    state.uploadFinishSize = value;
  },
  handleUploadList(state, value) {
    state.uploadList = value;
  },
  handleSubtitleTracks(state, value) {
    state.subtitleTracks = value;
  },
  handleSavePresetShow(state, value) {
    state.savePresetShowing = value;
  },
  handleSavePresetType(state, value) {
    state.savePresetType = value;
  },
  handleUserBasics(state, value) {
    state.userBasics = value;
  },
  handleTranslationLock(state, value) {
    state.translationLocked = value;
  },
  handleTranslationGenerate(state, value) {
    console.log('handleTranslationGenerate2',value);
    state.translationGenerated = value;
  },
  handleLinkMaterialVisible(state, value) {
    state.linkMaterialVisible = value;
  },
  handleVideoSeriesTagVisible(state, value) {
    state.videoSeriesTagVisible = value;
  },
  handleTextVideoSeriesTagVisible(state, value) {
    state.textVideoSeriesTagVisible = value;
  },
  handleVideoSeriesTagData(state, value) {
    state.videoSeriesTagData = {
      1: value[1] || {},
      2: value[2] || {}
    };
  },
  handleFontNameLookup(state, value) {
    state.fontNameLookup = value;
  },
  handleFontStates(state, value) {
    state.fontStates = value;
  },
  handleMusicFade(state, value) {
    state.musicFade = value;
  },
  handleCoverParams(state, value) {
    state.coverParams = value;
  },
  handleCoverWatermark(state, value) {
    state.coverWatermark = value;
  },
  handleMyMateriaChecked(state, value) {
    state.myMateriaChecked = value;
  },
  handleMyMateriaCheckedList(state, value) {
    state.myMateriaCheckedList = value;
  },
  handleVideoScripts(state, value) {
    state.videoScripts = value;
  },
  handleVideoScriptUse(state, value) {
    state.usedVideoScriptId = value;
  },
  handleCurrentPresetTemplate(state, value) {
    state.currentPresetTemplate = value;
  },
  handleVideoScriptScenes(state, value) {
    state.videoScriptScenes = value;
  },
  handleVideoScriptTypes(state, value) {
    state.videoScriptTypes = value;
  },
  handleVideoScriptPeekerVisible(state, value) {
    state.videoScriptPeekerVisible = value;
  },
  handleVideoScriptPreviewerVisible(state, value) {
    state.videoScriptPreviewerVisible = value;
  },
  handleVideoScriptPreviewerList(state, value) {
    state.videoScriptPreviewerList = value;
  },
  handleVideoSeriesTagMode(state, value) {
    state.videoSeriesTagMode = value;
  },
  handleVideoSeriesTagNames(state, value) {
    state.videoSeriesTagNames = value;
  },
  handleMenuCollapse(state, value) {
    state.menuCollapsed = value;
  },
  handleInitialize(state, value) {
    state.initialized = value;
  },
  handleMaterialColorVisible(state, value) {
    state.materialColorVisible = value;
  },
  handleMaterialColor(state, value) {
    state.materialColor = value;
  },
  handleTemplateUse(state, value) {
    state.usedTemplateId = value;
  },
  handleAlternateTemplates(state, value) {
    state.alternateTemplates = value;
  },
  handleMusicCategoryList(state, value) {
    state.musicCategoryList = value;
  },
  handleCustomTTSUse(state, value) {
    state.useCustomTTS = value;
  },
  handleCustomTTS(state, value) {
    state.customTTS = value;
  },
  handleCustomTTSIds(state, value) {
    state.customTTSIds = value;
  },
  handleSelectionDraw(state, value) {
    state.selectionDrawing = value;
  },
  handleSelectionArea(state, value) {
    state.selectionArea = value;
  },
  handleEffectPreselect(state, value) {
    state.preselectedEffectIds = value;
  },
  handleClipping(state, value) {
    state.clipping = value;
  },
  handleClippingEffect(state, value) {
    state.clippingEffect = value;
  },
  handleReadonly(state, value) {
    state.readonly = value;
  },
  handleSnapEnable(state, value) {
    state.snapEnabled = value;
  },
  handleDescKeywords(state, value) {
    state.descKeywords = value;
  },
  handleRecordDisabledVisible(state, value) {
    state.recordDialogVisible = value
  }
}
